import { Link } from 'react-router-dom';
import { useState } from 'react';

const NEWSLETTER_FORM_URL = 'http://rfeff.com/';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();

    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);

    const honeypot = (formData.get('company_alt') as string || '').trim();
    if (honeypot) {
      setSubmitStatus('success');
      setEmail('');
      setTimeout(() => setSubmitStatus('idle'), 3000);
      return;
    }

    formData.delete('company_alt');

    try {
      const response = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
        setFormError(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后再试');
      }
    } catch {
      setSubmitStatus('error');
      setFormError('网络错误，请检查连接后重试');
    }

    setTimeout(() => {
      setSubmitStatus('idle');
      setFormError('');
    }, 4000);
  };

  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-100 rounded-t-3xl mx-4 md:mx-6 mt-20">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
              订阅更新
            </h3>
            <p className="text-foreground-400 text-sm mb-6 leading-relaxed">
              第一时间获取最新韩漫更新资讯，不错过任何精彩内容
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="输入您的邮箱"
                className="flex-1 bg-white/10 border border-white/20 rounded-full px-5 py-3 text-sm text-white placeholder-foreground-500 focus:outline-none focus:border-primary-400 transition-colors"
              />
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-anti-bot"
              />
              <button
                type="submit"
                className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white rounded-full px-6 py-3 text-sm font-medium transition-colors cursor-pointer"
              >
                订阅 <i className="ri-arrow-right-line ml-1"></i>
              </button>
            </form>
            {submitStatus === 'success' && (
              <p className="text-green-400 text-sm mt-2">订阅成功！感谢您的关注。</p>
            )}
            {submitStatus === 'error' && (
              <p className="text-red-400 text-sm mt-2">{formError || '订阅失败，请稍后再试。'}</p>
            )}
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-foreground-400 hover:text-white text-sm transition-colors">首页</Link>
              <Link to="/category/all" className="text-foreground-400 hover:text-white text-sm transition-colors">全部分类</Link>
              <Link to="/about" className="text-foreground-400 hover:text-white text-sm transition-colors">关于我们</Link>
              <a href="#" className="text-foreground-400 hover:text-white text-sm transition-colors">帮助中心</a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-white mb-4">联系方式</h4>
            <div className="space-y-3 text-sm text-foreground-400">
              <p>hello@rfeff.com</p>
              <p>400-888-6666</p>
            </div>
            <div className="mt-6">
              <h4 className="text-sm font-semibold text-white mb-3">关注我们</h4>
              <div className="flex gap-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-white text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-white text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-white text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex gap-4 text-foreground-500 text-xs">
            <a href="#" className="hover:text-white transition-colors">隐私政策</a>
            <a href="#" className="hover:text-white transition-colors">服务条款</a>
          </div>
          <p className="text-foreground-500 text-xs text-center">
            &copy; {year} 韩漫之家 版权所有
          </p>
          <div className="flex gap-4 text-foreground-500 text-xs">
            <a href="#" className="hover:text-white transition-colors">友情链接</a>
            <a href="#" className="hover:text-white transition-colors">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}